/* Halden & Hale - Black Friday promotion config (single source of truth for the storefront).
   Discounts themselves live in Shopify Admin > Discounts; keep these dates and tiers in sync. */
(function(){
  var P=[
    {key:'bf',name:'Black Friday',start:Date.UTC(2026,9,20),end:Date.UTC(2026,11,2),t:[20,25,30]}
  ];
  function current(){var n=Date.now();for(var i=0;i<P.length;i++){if(n<P[i].end)return P[i];}return null;}
  function next(p){var i=P.indexOf(p);return i>-1&&i<P.length-1?P[i+1]:null;}
  function left(ms){var d=Math.max(0,ms-Date.now());return{d:Math.floor(d/864e5),h:Math.floor(d%864e5/36e5),m:Math.floor(d%36e5/6e4),s:Math.floor(d%6e4/1e3),ms:d};}
  function pad(n){return(n<10?'0':'')+n;}
  window.HHP={phases:P,current:current,next:next,left:left,pad:pad};

  function paint(){
    var p=current();
    document.querySelectorAll('[data-hh-promo]').forEach(function(el){el.hidden=!p;});
    if(!p)return;
    document.querySelectorAll('[data-hh-tier]').forEach(function(el){el.textContent=p.t[+el.getAttribute('data-hh-tier')]+'%';});
    document.querySelectorAll('[data-hh-phase]').forEach(function(el){el.textContent=p.name;});
    var l=left(p.end);
    document.querySelectorAll('[data-hh-cd]').forEach(function(el){
      var f=el.getAttribute('data-hh-cd');
      if(f==='d')el.textContent=pad(l.d);else if(f==='h')el.textContent=pad(l.h);else if(f==='m')el.textContent=pad(l.m);else if(f==='s')el.textContent=pad(l.s);
      else el.textContent=(l.d>0?l.d+'d ':'')+pad(l.h)+'h '+pad(l.m)+'m';
    });
  }
  window.HHP.paint=paint;
  if(document.readyState!=='loading')paint();else document.addEventListener('DOMContentLoaded',paint);
  setInterval(paint,1000);
})();
